import { useQuery } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';
import type { BusinessUnitDto } from '@/hooks/api/useAuth';

const httpClient = new HttpClient();

export async function fetchBusinessUnitsAll(): Promise<BusinessUnitDto[]> {
  const response = await httpClient.get<{ data: BusinessUnitDto[] }>(
    'api/business-units',
    {},
  );
  const body = response.data as { data?: BusinessUnitDto[] };
  return body?.data ?? [];
}

export function useBusinessUnitsAll(enabled = true) {
  return useQuery({
    queryKey: ['businessUnits', 'all'],
    queryFn: fetchBusinessUnitsAll,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
